module.exports = __webpack_public_path__ + "497fbaf41bf13185c78de3e9edba460b.pdf";